import { Box, Container } from "@sembark-travel/ui-base"
import {
	Breadcrumbs,
	useGetBackUrlFromLocation,
} from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { NewTransportPaymentPreferenceForm } from "../../../../SupplierPaymentPreferences"
import { generatePath, useNavigate } from "../../../../router-utils"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"

export default function NewTransportPaymentPreference() {
	const navigate = useNavigate()
	const backFromUrl = useGetBackUrlFromLocation()
	const listingPage = generatePath(
		"/org/supplier-payment-preferences/transport"
	)
	function navigateBackOrToList() {
		if (backFromUrl) {
			return navigate(
				backFromUrl as "/org/supplier-payment-preferences/transport"
			)
		}
		return navigate("/org/supplier-payment-preferences/transport")
	}
	return (
		<>
			<Helmet>
				<title>Add Transport Payment Preference</title>
			</Helmet>
			<ForbidUnlessAuthorized
				permission={PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS}
			>
				<Breadcrumbs
					title="New Preference"
					items={[
						[listingPage, "Supplier Payment Preferences"],
						[listingPage, "Transport"],
						["", "New"],
					]}
				/>
				<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
					<Box maxWidth="6xl" marginX="auto">
						<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
							<Container paddingY="6">
								<NewTransportPaymentPreferenceForm
									onSuccess={navigateBackOrToList}
									onCancel={navigateBackOrToList}
								/>
							</Container>
						</Box>
					</Box>
				</Box>
			</ForbidUnlessAuthorized>
		</>
	)
}
